import l10n from "@/services/l10n";

export default [
  {
    name: "genreAlbums",
    path: "/genres/:id/albums",
    icon: "genre",
    meta: { title: l10n("GENRE_ALBUMS") },
    component: () =>
      import(
        /* webpackChunkName: "albums-list" */ "@/pages/Genres/GenreAlbums.vue"
      )
  },
  {
    name: "genreArtists",
    path: "/genres/:id/artists",
    icon: "genre",
    meta: { title: l10n("GENRE_ARTISTS") },
    component: () =>
      import(
        /* webpackChunkName: "artists-list" */ "@/pages/Genres/GenreArtists.vue"
      )
  },
  {
    name: "genreTracks",
    path: "/genres/:id/tracks",
    icon: "genre",
    meta: { title: l10n("GENRE_TRACKS") },
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Genres/GenreTracks.vue"
      )
  },
  {
    name: "genreChart",
    path: "/genres/:id/chart",
    icon: "genre",
    meta: { title: l10n("GENRE_TOP_100") },
    component: () =>
      import(
        /* webpackChunkName: "genres-chart" */ "@/pages/Genres/GenreChart.vue"
      )
  },
  {
    name: "genre",
    path: "/genres/:id",
    icon: "genre",
    meta: { title: l10n("GENRE") },
    component: () =>
      import(/* webpackChunkName: "fullview" */ "@/pages/Genres/Genre.vue")
  }
];
